import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import GetCustomersPage             from "../../../application/usecase/customer/GetCustomersPage";
import Customers                    from "../../../domain/customer/Customers";
import { ResKaState }               from "../../../index";
import ListPagination               from "../common/ListPagination";

const CustomersPagination: FC = () => {
  const customers: Customers = useSelector((state: ResKaState) => state.customers);
  const getCustomersPage: GetCustomersPage = new GetCustomersPage(useDispatch());
  return (
    <>
      <ListPagination
        currentPage={ customers.pagination.current }
        totalPage={ customers.pagination.total }
        onChangePage={ currentPage => getCustomersPage.execute(currentPage, customers.search, customers.sortType) }
      />
    </>
  );
};

export default CustomersPagination;
